// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".continuous-text[data-v-cfdb104e]{width:6.03865rem}.fn-content-8__controlbar__item[data-v-cfdb104e]{align-items:flex-start}", ""]);
// Exports
module.exports = exports;
